/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import * as ActiveStorage from '@rails/activestorage'
ActiveStorage.start()

// Import all ActionCable channels
// const channels = import.meta.globEager ('./**/*_channel.js')

// Build a FontAwesome icon library to use throughout the app. Add icons below as needed
// Source: https://fontawesome.com/v5/docs/web/use-with/react#using-icons-via-global-use
import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faArrowLeft,
  faArrowRight,
  faBolt,
  faBook,
  faCaretDown,
  faChalkboardTeacher,
  faCheck,
  faCheckCircle,
  faClipboardList,
  faClock,
  faClosedCaptioning,
  faCog,
  faComment,
  faCommentDots,
  faEdit,
  faEllipsisH,
  faEnvelope,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFile,
  faGlobeAmericas,
  faHourglass,
  faInbox,
  faInfoCircle,
  faLink,
  faMagic,
  faPaperPlane,
  faPlus,
  faPlusCircle,
  faPoll,
  faQuestionCircle,
  faRedoAlt,
  faSearch,
  faShareSquare,
  faSignInAlt,
  faStopwatch,
  faTimes,
  faTrash,
  faUserCircle,
  faUsers,
  faVideo,
  faWindowClose,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faArrowLeft,
  faArrowRight,
  faBolt,
  faBook,
  faCaretDown,
  faChalkboardTeacher,
  faCheck,
  faCheckCircle,
  faClipboardList,
  faClock,
  faClosedCaptioning,
  faCog,
  faComment,
  faCommentDots,
  faEdit,
  faEllipsisH,
  faEnvelope,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFile,
  faGlobeAmericas,
  faHourglass,
  faInbox,
  faInfoCircle,
  faLink,
  faMagic,
  faPaperPlane,
  faPlus,
  faPlusCircle,
  faPoll,
  faQuestionCircle,
  faRedoAlt,
  faSearch,
  faShareSquare,
  faSignInAlt,
  faStopwatch,
  faTimes,
  faTrash,
  faUserCircle,
  faUsers,
  faVideo,
  faWindowClose,
);

import '../lib/window_functions';
